 /* eslint-disable */ 
 let tag= process.env.VUE_APP_TAG
 let new_service_basis=getEnv(tag).service_basis

export default {
  // 标注项目接口
  /**
   * 获取积木列表
   */
  getBlockList: `${new_service_basis}/ai/training/project/getBlockList`,
  /**
   * 获取积木列表 -- 我的模型和公共模型部分
   */
  getModelBlockList: `${new_service_basis}/ai/training/project/getModelBlockList`,
  /**
   * 获取积木列表 -- 实训模型部分
   */
  getTrainModelBlockList: `${new_service_basis}/ai/training/project/getTrainModelBlockList`,
  /**
   * 保存项目代码
   */
  saveProjectCode: `${new_service_basis}/ai/training/project/saveProjectCode`,
  /**
   * 提交项目代码
   */
  submitProjectCode: `${new_service_basis}/ai/training/project/submitProjectCode`,
  /**
   * 获取项目信息
   */
  getProjectInfo: `${new_service_basis}/ai/training/project/getProjectInfo`,
  /**
   * 根据实训id查询实训信息
   */
  getTrainingByTrainingId: `${new_service_basis}/ai/training/training/getTrainingByTrainingId`,
  /**
   * 新增自定义积木
   */
  insertDefBlocks: `${new_service_basis}/ai/training/project/insertDefBlocks`,
  /**
   * 获取自定义积木
   */
  getDefBlocksByUserId: `${new_service_basis}/ai/training/project/getDefBlocksByUserId`,
  /**
   * 删除自定义积木
   */
   deleteDefBlocks: `${new_service_basis}/ai/training/project/deleteDefBlocks`,
  /**
   * 查询媒体积木
   */
  getMediaByTrainingId: `${new_service_basis}/ai/training/project/getMediaByTrainingId`,
  /**
   * 删除媒体积木
   */
  deleteMedia: `${new_service_basis}/ai/training/project/deleteMedia`,
  /**
   * 修改媒体积木
   */
  updateMedia: `${new_service_basis}/ai/training/project/updateMedia`,
  /**
   *  新增媒体积木
   */
  insertMedia: `${new_service_basis}/ai/training/project/insertMedia`,

};
